// async import of sentry to prevent blocking the main thread
// and to keep the bundle size small
if (process.env.REACT_APP_ACTIVE_SENTRY === 'true') {
  import('./sentry')
}
